import { render, staticRenderFns } from "./UserCenterSetting.vue?vue&type=template&id=e3358bc4&scoped=true&"
import script from "./UserCenterSetting.vue?vue&type=script&lang=ts&"
export * from "./UserCenterSetting.vue?vue&type=script&lang=ts&"
import style0 from "./UserCenterSetting.vue?vue&type=style&index=0&id=e3358bc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3358bc4",
  null
  
)

export default component.exports